"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createDynamicContextFunction_1 = require("./createDynamicContextFunction");
const findAttribute_1 = __importDefault(require("./findAttribute"));
const getComponentText_1 = __importDefault(require("./getComponentText"));
const componentAttributeProperties = [
    'component_type',
    'component_subtype',
    'preselected_count',
    'total_objects_available',
    'total_objects_displayed',
    'user_selected_count',
];
const componentAttributeTypes = {
    component_type: 'string',
    component_subtype: 'string',
    preselected_count: 'integer',
    total_objects_available: 'integer',
    total_objects_displayed: 'integer',
    user_selected_count: 'float',
    label: 'string',
    element_id: 'string',
    element_key: 'string',
    is_visible: 'boolean',
    visibility_percentage: 'float',
};
const generateComponentContext = (element) => {
    const label = (0, getComponentText_1.default)(element) !== null && (0, getComponentText_1.default)(element) !== undefined
        ? (0, getComponentText_1.default)(element)
        : '';
    const data = { label };
    const elementId = element.id;
    if (elementId !== null) {
        data.element_id = elementId;
    }
    const key = element.getAttribute('data-snowplow-component-key');
    if (key !== null) {
        data.element_key = key;
    }
    componentAttributeProperties.forEach((prop) => {
        const formattedProp = (0, createDynamicContextFunction_1.snakeToKebab)(prop);
        const attribute = (0, findAttribute_1.default)(element, `data-snowplow-${formattedProp}`);
        if (attribute !== null) {
            const propType = componentAttributeTypes[prop];
            const formattedAttribute = (0, createDynamicContextFunction_1.parseAttribute)(attribute, propType);
            data[prop] = formattedAttribute;
        }
    });
    return data;
};
exports.default = generateComponentContext;
//# sourceMappingURL=data:application/json;base64,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


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/generateComponentContext.ts